import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import cx from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import { CardIcons } from '../credit-card-icons';
import OrderCard from '../order-card';
import InLineItem from './in-line-items/in-line-item';
import FulfilmentMethod from './fulfilment-method/fulfilment-method';
import TermsAndConditionsAndPrivacyStatement from './terms-and-conditions/terms-and-conditions';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PRICE_PRECISION = 2;

const displayPrice = price => "$".concat(price.toFixed(PRICE_PRECISION));

const displayDiscount = price => "-$".concat(price.toFixed(PRICE_PRECISION));

export const OrderSummary = _ref => {
  let {
    itemCount,
    subTotal,
    fees,
    total,
    heading,
    totalText,
    submitButtons,
    displaySubTotalText,
    className,
    totalHelpText = 'Incl GST (if any)',
    displayTermsAndConditions = false,
    handleChange,
    termsAndConditionsUrl,
    privacyPolicyUrl,
    checkboxValue,
    errorMessage,
    couponCodeEntry,
    fulfilmentMethods,
    shippingDeadlineWarning
  } = _ref;
  const totalFees = (fees !== null && fees !== void 0 ? fees : []).reduce((acc, fee) => acc + fee.price, 0);
  const discount = subTotal + totalFees - total;
  return /*#__PURE__*/_jsxs(OrderCard, {
    heading: heading || 'Order summary',
    headerUnderline: false,
    className: cx(className, style.orderSummaryWrapper),
    "data-id": "order-summary_index_OrderSummary_OrderCard",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.orderSummaryDetail,
      "data-id": "order-summary_index_OrderSummary_OrderCard_div",
      children: [/*#__PURE__*/_jsx(InLineItem, {
        heading: "".concat(itemCount, " ").concat( // eslint-disable-next-line eqeqeq
        itemCount > 1 || itemCount == 0 ? 'items' : 'item'),
        value: displayPrice(subTotal),
        "data-id": "order-summary_index_OrderSummary_div_InLineItem"
      }), discount > 0 && /*#__PURE__*/_jsx(InLineItem, {
        heading: 'Discount',
        value: displayDiscount(discount),
        "data-id": "order-summary_index_OrderSummary_InLineItem_3"
      }, 'discount'), fees && fees.length > 0 && fees.map(_ref2 => {
        let {
          name,
          price
        } = _ref2;
        return /*#__PURE__*/_jsx(InLineItem, {
          heading: name,
          value: price === 0 ? 'Free' : displayPrice(price),
          "data-id": "order-summary_index_OrderSummary_InLineItem_4"
        }, name);
      })]
    }), couponCodeEntry && /*#__PURE__*/_jsx(_Fragment, {
      children: couponCodeEntry
    }), /*#__PURE__*/_jsx("div", {
      className: style.orderSummaryTotal,
      "data-id": "order-summary_index_OrderSummary_OrderCard_div",
      children: /*#__PURE__*/_jsx(InLineItem, {
        boldHeading: true,
        boldValue: true,
        largeValueSize: true,
        heading: displaySubTotalText ? 'Subtotal' : totalText || 'Total',
        value: displayPrice(total),
        helpText: totalHelpText,
        deliveryText: displaySubTotalText ? 'Excludes delivery fee' : undefined,
        "data-id": "order-summary_index_OrderSummary_div_InLineItem"
      })
    }), fulfilmentMethods && /*#__PURE__*/_jsx("div", {
      className: style.orderSummaryFulfilment,
      "data-id": "order-summary_index_OrderSummary_div",
      children: fulfilmentMethods.map(fulfilmentMethod => /*#__PURE__*/_jsx(FulfilmentMethod, _objectSpread(_objectSpread({}, fulfilmentMethod), {}, {
        "data-id": "order-summary_index_OrderSummary_FulfilmentMethod"
      }), fulfilmentMethod.label))
    }), displayTermsAndConditions && handleChange && termsAndConditionsUrl && privacyPolicyUrl && checkboxValue !== undefined && /*#__PURE__*/_jsx("div", {
      className: style.termsAndConditionsAndPrivacyStatement,
      "data-id": "order-summary_index_OrderSummary_div",
      children: /*#__PURE__*/_jsx(TermsAndConditionsAndPrivacyStatement, {
        value: checkboxValue,
        termsAndConditionUrl: termsAndConditionsUrl,
        privacyPolicyUrl: privacyPolicyUrl,
        errorMessage: errorMessage,
        onChange: handleChange,
        "data-id": "order-summary_index_OrderSummary_div_TermsAndConditionsAndPrivacyStatement"
      })
    }), shippingDeadlineWarning && /*#__PURE__*/_jsx("div", {
      className: style.shippingDeadline,
      "data-id": "order-summary_index_OrderSummary_div",
      children: shippingDeadlineWarning
    }), /*#__PURE__*/_jsx("div", {
      className: style.submitButtons,
      "data-id": "order-summary_index_OrderSummary_OrderCard_div_12",
      children: submitButtons
    }), /*#__PURE__*/_jsxs("div", {
      className: style.securePayment,
      "data-id": "order-summary_index_OrderSummary_OrderCard_div_13",
      children: [/*#__PURE__*/_jsxs("span", {
        "data-id": "order-summary_index_OrderSummary_div_span",
        children: [/*#__PURE__*/_jsx(Icon, {
          size: "medium",
          type: "padlock-locked",
          className: style.secureIcon,
          "data-id": "order-summary_index_OrderSummary_span_Icon"
        }), "Transactions are secure and encrypted", ' ']
      }), /*#__PURE__*/_jsx(CardIcons, {
        className: style.cardIcons,
        "data-id": "order-summary_index_OrderSummary_div_CardIcons"
      })]
    })]
  });
};
export default OrderSummary;